import { render, staticRenderFns } from "./TachographWrongDriverData.vue?vue&type=template&id=477f7fcb&"
import script from "./TachographWrongDriverData.vue?vue&type=script&lang=js&"
export * from "./TachographWrongDriverData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports